import { KendoBaseComponent, KendoBaseDatasourceComponent, KendoSharedMethods } from '@progress/kendo-base-components-vue-wrapper'
import PanelBarProps from './PanelBarProps'

import Animation from './Animation'
import Messages from './Messages'

export default {
    props: PanelBarProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        KendoSharedMethods,
        Animation,
        Messages
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoPanelBar(this.widgetOptions)
        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoPanelBar()
        },
        _resolveChildren() {
            const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
            const hasDataSource = this.v3 ? (!this.$props.dataSource) : (this.$options.propsData && !this.$options.propsData['dataSource'])
            if(hasDataSource && defaultSlot){
                var items = this.resolveInnerTags('kendo-panelbar-item')

                if(items.length) {
                    this.widgetOptions['dataSource'] = items
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoPanelBar/KendoPanelBarMixin.js